import { useQuery } from '@tanstack/react-query';
import { strapiGetQuotation } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useQuotationDetailQuery(jwt: string | null, documentId: string | null) {
  return useQuery({
    queryKey: queryKeys.quotationDetail(jwt, documentId),
    queryFn: () => strapiGetQuotation(jwt!, documentId!),
    enabled: Boolean(jwt && documentId),
  });
}
